/**
 * Copyright (c) 2019 ООО Код Ускорения Бизнеса - All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
 */

/* eslint no-shadow: ["error", { "allow": ["state"] }] */
/* eslint
  no-param-reassign: ["error", { "props": true, "ignorePropertyModificationsFor": ["state"] }] */

// initial state
const state = {
  menu: true,
  debugMode: false,
  mobileSideBarMenu: false,
};

// getters
const getters = {};

// actions
const actions = {
  setDebugMode({ commit }, isDebug) {
    commit('setDebugMode', isDebug);
  },
  showMenu({ commit }) {
    commit('setMenuStatus', true);
  },
  hideMenu({ commit }) {
    commit('setMenuStatus', false);
  },
  setMobileSideBarMenu({ commit }, mobileSideBarMenu) {
    commit('setMobileSideBarMenu', mobileSideBarMenu);
  },
};

// mutations
const mutations = {
  setMenuStatus(state, status) {
    state.menu = status;
  },
  setDebugMode(state, isDebug) {
    state.debugMode = isDebug;
  },
  setMobileSideBarMenu(state, mobileSideBarMenu) {
    state.mobileSideBarMenu = mobileSideBarMenu;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
